import * as stylex from "@stylexjs/stylex";
import type { FunctionComponent } from "preact";

import polychrome from "../assets/polychrome.png";

const styles = stylex.create({
    container: {
        paddingLeft: "2px",
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "last",
        fontWeight: "500",
        fontFamily: "'Inter Variable', sans-serif",
        fontSize: "inherit",
        color: "#444",
        "@supports (vertical-align: -webkit-baseline-middle)": {
            verticalAlign: "sub",
        }
    },
});

const CurrencyDisplay: FunctionComponent<{ amount: number; label?: string | null }> = ({
    amount,
    label,
}) => (
    <div {...stylex.props(styles.container)}>
        <img
            src={polychrome}
            alt="Polychrome"
            width="20"
            draggable={false}
            style={{ verticalAlign: "center" }}
        />
        <b>
            {amount}
            {label && <>&nbsp; {label}</>}
        </b>
    </div>
);

export default CurrencyDisplay;
